import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  batchState: string
}

const DisbursementBatchStateChip: React.FC<ComponentProps> = ({ batchState }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (batchState === 'PENDING') {
    color = 'primary'
    variant = 'outlined'
  } else if (batchState === 'EXPORTED') {
    color = 'primary'
    variant = 'outlined'
  } else if (batchState === 'PROCESSED') {
    color = 'success'
    variant = 'outlined'
  } else if (batchState === 'CANCELLED') {
    color = 'error'
    variant = 'outlined'
  }

  return (
    <>
      {batchState === undefined
        ? (
          <></>
          )
        : (
            <Tooltip title={batchState} TransitionComponent={Zoom} arrow placement='bottom'>
              <Chip label={batchState} variant={variant} color={color} />
            </Tooltip>
          )
      }
    </>
  )
}

export default DisbursementBatchStateChip
